export const formatDate = (date: Date | null) => {
  if (!date) { return '' }
  return new Intl.DateTimeFormat("en-US").format(date);
}

export const formatDateToInputString = (date: Date | null) => {
  if (!date) { return '' }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Add these helper functions
export const getFirstMondayOfMonth = (date: Date): Date => {
  const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  const dayOfWeek = firstDay.getDay();
  const firstMonday = new Date(firstDay);
  firstMonday.setDate(firstDay.getDate() + ((7 - dayOfWeek + 1) % 7 || 7));
  return new Date(firstMonday.setHours(0, 0, 0, 0));
};

export const getThirdMondayOfMonth = (date: Date): Date => {
  const firstMonday = getFirstMondayOfMonth(date);
  const thirdMonday = new Date(firstMonday);
  thirdMonday.setDate(firstMonday.getDate() + 14); // Add 2 weeks
  return new Date(thirdMonday.setHours(0, 0, 0, 0));
};

export const getNextPaymentDate = (weekStart: Date): Date => {
  const firstMonday = getFirstMondayOfMonth(weekStart);
  const thirdMonday = getThirdMondayOfMonth(weekStart);
  
  // If the week starts before or on the first Monday, payment is on first Monday
  if (weekStart <= firstMonday) {
    return firstMonday;
  }
  // If the week starts before or on the third Monday, payment is on third Monday
  if (weekStart <= thirdMonday) {
    return thirdMonday;
  }
  // If we're past the third Monday, payment is on the first Monday of next month
  const nextMonth = new Date(weekStart.getFullYear(), weekStart.getMonth() + 1, 1);
  return getFirstMondayOfMonth(nextMonth);
};

export const getNextMonday = (date: Date): Date => {
  const result = new Date(date);
  result.setDate(result.getDate() + ((7 - result.getDay() + 1) % 7 || 7));
  return new Date(result.setHours(0, 0, 0, 0));
};

export const getPreviousMonday = (date: Date): Date => {
  const result = new Date(date);
  result.setDate(result.getDate() - ((result.getDay() + 6) % 7));
  return new Date(result.setHours(0, 0, 0, 0));
};

export const getWeekNumber = (date: Date): number => {
  const startOfYear = new Date(date.getFullYear(), 0, 1);
  const days = Math.floor((date.getTime() - startOfYear.getTime()) / (24 * 60 * 60 * 1000));
  return Math.ceil((days + startOfYear.getDay() + 1) / 7);
};